import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Card from 'react-toolbox/lib/card';
import qs from 'qs';
import LoginForm from '../LoginForm';
import CardBody from '../CardBody';
import Logo from '../Logo';
import { httpGet } from '../../http';
import LeftPane from '../layout/LeftPane';
import { fetchPrivacyPolicy } from '../../apps/login/api-sdk';
import Markdown from '../Markdown';
import styles from './LoginPage.scss';
import ConsentForm from '../ConsentForm';
import LoginErrorView from '../LoginErrorView';
import LoginLoadingView from '../LoginLoadingView';

const propTypes = {
  entries: PropTypes.array,
  meta: PropTypes.object,
  carouselContainer: PropTypes.object,
  onEmailBlur: PropTypes.func, // called when email/userid field loses focus
};

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.attemptLogin = this.attemptLogin.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isLoading: false,
      privacyPolicy: null,
      credentials: null,
    };
  }

  attemptLogin() {
    this.formEl.submit();
  }

  handleSubmit(values, e) {
    this.formEl = e.target;
    // Save values in state so we can continue the login upon consent
    // of privacy policy
    this.setState({
      credentials: values,
      isLoading: true,
    });
    httpGet(`/api/consent?email=${encodeURIComponent(values.username)}`).then(
      response => {
        if (response.consent === true) {
          this.attemptLogin(values, e);
        } else {
          fetchPrivacyPolicy()
            .then(privacyPolicy => {
              this.setState({
                privacyPolicy,
                isLoading: false,
              });
            })
            .catch(() => {
              this.setState({
                isLoading: false,
                error: true,
              });
            });
        }
      }
    );
  }

  renderLoginForm(show) {
    const query = qs.parse(window.location.search.replace('?', ''));
    const { carouselContainer = {} } = this.props;

    // Hide the form. If using `.sr-only` then LastPass input markers will still be visible
    const formStyle = show ? {} : { display: 'none ' };
    const childs = [
      <div key="loginWrapper" className={styles.loginWrapper} style={formStyle}>
        <Card key="loginCard" className={`${styles.loginFormCard}`}>
          <CardBody>
            <Logo />
            <LoginForm
              error={query.error}
              {...this.props}
              onSubmit={this.handleSubmit}
            />
          </CardBody>
        </Card>
      </div>,
    ];
    if (carouselContainer.footerCopy && show) {
      childs.push(
        <Markdown
          key="footerContent"
          className={`${styles.footer} py-2`}
          source={carouselContainer.footerCopy || ''}
        />
      );
    }
    return childs;
  }

  render() {
    const { isLoading, privacyPolicy, error } = this.state;
    const showLoginForm = !privacyPolicy && !isLoading;
    if (error) {
      return (
        <LoginErrorView error="Could not load Privacy Policy. Please try again later" />
      );
    }
    return (
      <LeftPane
        className="col-xs-12 col-sm-6"
        contentClassName={privacyPolicy ? styles.hasTextContent : null}
      >
        <Helmet title="Login" />
        {isLoading && <LoginLoadingView />}
        <ConsentForm content={privacyPolicy} onSubmit={this.attemptLogin} />
        {privacyPolicy && (
          <ConsentForm content={privacyPolicy} onSubmit={this.attemptLogin} />
        )}
        {this.renderLoginForm(showLoginForm)}
      </LeftPane>
    );
  }
}

LoginPage.propTypes = propTypes;

export default LoginPage;



// WEBPACK FOOTER //
// ./src/client/src/components/pages/LoginPage.js